module.exports = __webpack_public_path__ + "static/media/CE1117.c6854736.pdf";